export type SubscriptionPlanId = 'starter' | 'growth' | 'scale'

export interface SubscriptionPlan {
  id: SubscriptionPlanId
  name: string
  price: number
  minutes: number
  overageRate: number
  description: string
  recommended?: boolean
}

export const SUBSCRIPTION_PLANS: SubscriptionPlan[] = [
  {
    id: 'starter',
    name: 'Starter',
    price: 14.99,
    minutes: 180,
    overageRate: 0.12,
    description: 'For lighter call volumes and getting started with Vexu.',
  },
  {
    id: 'growth',
    name: 'Growth',
    price: 39.99,
    minutes: 500,
    overageRate: 0.1,
    description: 'For busy professionals who rely on their assistant every day.',
    recommended: true,
  },
  {
    id: 'scale',
    name: 'Scale',
    price: 79.99,
    minutes: 1000,
    overageRate: 0.9,
    description: 'For high-volume teams that need room to grow.',
  },
]

export const DEFAULT_SUBSCRIPTION_PLAN_ID: SubscriptionPlanId = 'starter'

export interface PromoCodeResult {
  code: string
  description: string
  firstMonthDiscountPercent: number
}

const PROMO_CODES: Record<string, PromoCodeResult> = {
  VEXU20: {
    code: 'VEXU20',
    description: '20% off your first month',
    firstMonthDiscountPercent: 20,
  },
}

export function validatePromoCode(value: string): PromoCodeResult | null {
  return PROMO_CODES[value.trim().toUpperCase()] ?? null
}

export function getSubscriptionPlan(id: SubscriptionPlanId): SubscriptionPlan {
  return (
    SUBSCRIPTION_PLANS.find((plan) => plan.id === id) ?? SUBSCRIPTION_PLANS[0]
  )
}

export function formatCurrency(value: number): string {
  return `$${value.toFixed(2)}`
}
